import { render, staticRenderFns } from "./orderMontyStatistic.vue?vue&type=template&id=2b5aa91e&scoped=true"
import script from "./orderMontyStatistic.vue?vue&type=script&lang=js"
export * from "./orderMontyStatistic.vue?vue&type=script&lang=js"
import style0 from "./orderMontyStatistic.vue?vue&type=style&index=0&id=2b5aa91e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5aa91e",
  null
  
)

export default component.exports